import { render } from "./NewPage.vue?vue&type=template&id=2bb83404&scoped=true"
import script from "./NewPage.vue?vue&type=script&lang=js"
export * from "./NewPage.vue?vue&type=script&lang=js"

import "./NewPage.vue?vue&type=style&index=0&id=2bb83404&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2bb83404"

export default script